import { attachAppLinkAttribution } from "./attribution";
import { resolveSitePath } from "./languages";

const root = document.getElementById("site-root");
if (root === null) throw new Error("Site root is missing");
// The webapp's origin, which the page's app links name: written by the build
// and rewritten by front-serve per host, so the client renders the same links.
const appOrigin = root.dataset.appOrigin;
if (appOrigin === undefined) throw new Error("Site root has no app origin");
// The api the homepage's mic calls, rewritten per host the same way.
const apiOrigin = root.dataset.apiOrigin;
if (apiOrigin === undefined) throw new Error("Site root has no api origin");
// The pages the build holds (`SiteRelease`): the hydrated menus list them.
const release = root.dataset.release;
if (release !== "public" && release !== "preview")
  throw new Error(`Site root has no release: ${String(release)}`);
const route = resolveSitePath(globalThis.location.pathname);
// `vite dev` serves the homepage through its entry file (`site-dev-routes`).
const path = route.path === "site-entry.html" ? "" : route.path;

attachAppLinkAttribution();

// A language picked from a menu is the visitor's choice: from then on `/`
// opens that language's home, whatever the browser asks (front-serve). The
// menu's link to `/` names its language too (`languageMenuHref`), so the server
// keeps that choice without this script.
for (const link of document.querySelectorAll("a"))
  if (link.hreflang !== "")
    link.addEventListener("click", () => {
      document.cookie = `site_language=${link.hreflang}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
    });

// One chunk per language: a hydrated page loads only its own language's file.
const messageFiles = import.meta.glob("./locales/*/site.json", {
  import: "default",
});

if (path === "") {
  // The homepage is static HTML: nothing renders it on the client.
  void import("./home/interactions").then(({ attachHomePage }) => {
    attachHomePage(appOrigin, apiOrigin, route.language);
  });
} else if (root.dataset.renderMode !== "static") {
  // Loaded here only: the static homepage never renders React.
  const load = messageFiles[`./locales/${route.language}/site.json`];
  void Promise.all([
    import("react-dom/client"),
    import("./SitePage"),
    import("./copy"),
    route.language === "en" || load === undefined ? null : load(),
  ]).then(([{ createRoot, hydrateRoot }, { SitePage }, copy, messages]) => {
    if (route.language !== "en" && messages === null)
      throw new Error(
        `Site copy: locales/${route.language}/site.json is missing`
      );
    const siteCopy = copy.createSiteCopy(
      route.language,
      messages === null ? null : copy.siteMessagesSchema.parse(messages)
    );
    const page = (
      <SitePage
        siteCopy={siteCopy}
        path={path}
        appOrigin={appOrigin}
        release={release}
      />
    );
    if (root.childElementCount === 0) createRoot(root).render(page);
    else hydrateRoot(root, page);
  });
}
